import { createSlice } from "@reduxjs/toolkit";
import { get_user_thunk, google_login_thunk, logout_thunk, update_user_thunk } from "./authThunk";

const initialState = {
  loading: false,
  user: null,
  error: null,
  isLogin: false,
};

const loginCases = (builder) => {
  builder
    .addCase(google_login_thunk.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(google_login_thunk.fulfilled, (state, action) => {
      // state.user = action.payload.data.response;
      state.isLogin = true;
      state.loading = false;
    })
    .addCase(google_login_thunk.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload || "Login Cases Error";
    });
};

const getUserCases = (builder) => {
  builder
    .addCase(get_user_thunk.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(get_user_thunk.fulfilled, (state, action) => {
      state.user = action.payload.data.response;
      state.loading = false;
    })
    .addCase(get_user_thunk.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload || "Get User Cases Error";
    });
};
const updateUserCases = (builder) => {
  builder
    .addCase(update_user_thunk.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(update_user_thunk.fulfilled, (state, action) => {
      state.user = action.payload.data.response;
      state.loading = false;
    })
    .addCase(update_user_thunk.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload || "Update User Cases Error";
    });
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    setIsLogin: (state, action) => {
      state.isLogin = action.payload;
    },
    setUserShortcut: (state, action) => {
      state.user = {
        ...state.user,
        defaultFolderShortcut: action.payload
      };
    }
  },
  extraReducers: (builder) => {
    loginCases(builder);
    getUserCases(builder);
    updateUserCases(builder);
    // logoutCases(builder);
  },
});

export const { clearError, setIsLogin,setUserShortcut } = authSlice.actions;

export default authSlice.reducer;
